export const Sunrise = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 28H30" stroke="currentColor" stroke-width="2"/>
<path d="M25 23H30" stroke="currentColor" stroke-width="2"/>
<path d="M22.3867 17.6055L25.894 14.0952" stroke="currentColor" stroke-width="2"/>
<path d="M7 23.0076H2" stroke="currentColor" stroke-width="2"/>
<path d="M9.61328 17.613L6.10596 14.1028" stroke="currentColor" stroke-width="2"/>
<path d="M16.0358 14.9719V5.95142" stroke="currentColor" stroke-width="2"/>
<path d="M20.3022 9.70996L16.0083 5.42676L11.7109 9.70703" stroke="currentColor" stroke-width="2"/>
<path d="M20.9909 24.0029C20.9909 21.2431 18.7536 19.0059 15.9938 19.0059C13.234 19.0059 10.9967 21.2431 10.9967 24.0029" stroke="currentColor" stroke-width="2"/>
</svg>`;
